import Title from "../Title/Title";
import Accordion from "../Accordion/Accordion";
import React from "react";
import {IAccordion} from "../Accordion/interfaces";

interface Props {
  title: string;
  className?: string;
  items: IAccordion[];
  expanded: boolean;
}

export const Faq = ({title = 'Часто задаваемые вопросы', className = '', items  = [], expanded = true} : Props) => {
  return (<>
    <Title center title={title}/>
    <div className={className}>
      {items.map((item, i) => (
        <Accordion {...item} key={i} expanded={expanded}/>
      ))}
    </div>
  </>)
}
